import { Button, Flex, IconButton, XMarkIcon } from 'components'
import { startCase } from 'lodash-es'
import { DCFilter } from 'types'
import { getFilterKey, getFiltersFromConditions, LeadTableColumn } from '../utils'

interface Props {
  columns?: LeadTableColumn[]
  filters: DCFilter[]
  onRemove?: (filter: DCFilter) => void
  selectedFilter: DCFilter
  onClick: (filter: DCFilter) => void
}

export default function FilterTabs({
  columns,
  filters,
  onRemove,
  selectedFilter,
  onClick,
}: Props) {
  const combinedFilters = getFiltersFromConditions(filters, columns)
  const selectedKey = getFilterKey(selectedFilter, columns)
  const hasSelectedInDraft = combinedFilters.some(f => getFilterKey(f, columns) === selectedKey)
  const uniqueFilters = hasSelectedInDraft ? combinedFilters : [...combinedFilters, selectedFilter]

  return (
    <Flex direction="column" gap={1} overflowY="auto">
      {uniqueFilters.map(filter => {
        const filterKey = getFilterKey(filter, columns)
        return (
          <FilterTabButton
            key={filterKey}
            isCurrent={filterKey === selectedKey}
            label={filter.secondaryTargetValue ? filter.secondaryTargetValue : filter.field}
            onRemove={onRemove ? () => onRemove(filter) : undefined}
            onClick={() => onClick(filter)}
          />
        )
      })}
    </Flex>
  )
}

interface FilterTabButtonProps {
  isCurrent: boolean
  label: string
  onRemove?: () => void
  onClick: () => void
}

function FilterTabButton({ isCurrent, label, onRemove, onClick }: FilterTabButtonProps) {
  return (
    <Flex align="center" gap={1} w="100%">
      <Button
        flex={1}
        bg={isCurrent ? 'rgba(60, 75, 211, 0.1)' : undefined}
        color={isCurrent ? 'primary.500' : undefined}
        justifyContent="flex-start"
        variant="ghost"
        onClick={onClick}
      >
        {startCase(label)}
      </Button>
      {onRemove && (
        <IconButton
          aria-label="Remove filter"
          icon={<XMarkIcon size="sm" />}
          size="sm"
          variant="ghost"
          onClick={e => {
            e.stopPropagation()
            onRemove()
          }}
        />
      )}
    </Flex>
  )
}
